import { AdminStateContext } from "@/contexts/AdminStateProvider";

import { useContext } from "react";
import { Button } from "./ui/button";
import { ArrowLeftFromLineIcon } from "lucide-react";

export const UserViewCancelAsAdmin = () => {
  const { isAuthenticated, isUserViewing, setIsUserViewing } = useContext(AdminStateContext);
  return (
    (isAuthenticated && isUserViewing) ? (
      <Button
      variant={"secondary"}
      className="w-full rounded-none flex justify-start fixed bottom-0 left-0 right-0 z-50"
      onClick={() => setIsUserViewing(false)}>
        <ArrowLeftFromLineIcon size={16} className="mr-2" />
        Back to Admin View
      </Button>
    ) : null
  );
};
